import { categories } from '../data/categories';

// Создаем маппинг английских категорий на русские названия
// Используем все категории (включая disabled) для корректного маппинга
const categoryMap: Record<string, string> = {};
categories.forEach(category => {
    categoryMap[category.id] = category.name;
});

// Создаем обратный маппинг русских названий на английские ID
const reverseCategoryMap: Record<string, string> = {};
categories.forEach(category => {
    reverseCategoryMap[category.name] = category.id;
});

/**
 * Преобразует массив английских ID категорий в массив русских названий
 * @param englishCategories - массив английских ID категорий
 * @returns массив русских названий категорий
 */
export const mapCategoriesToRussian = (englishCategories: string[]): string[] => {
    return englishCategories.map(categoryId => categoryMap[categoryId] || categoryId).filter(Boolean);
};

/**
 * Получает русское название категории по её английскому ID
 * @param categoryId - английский ID категории
 * @returns русское название категории или исходный ID, если маппинг не найден
 */
export const getCategoryRussianName = (categoryId: string): string => {
    return categoryMap[categoryId] || categoryId;
};

/**
 * Преобразует массив русских названий категорий в массив английских ID
 * @param russianCategories - массив русских названий категорий
 * @returns массив английских ID категорий
 */
export const mapCategoriesToEnglish = (russianCategories: string[]): string[] => {
    return russianCategories.map(categoryName => reverseCategoryMap[categoryName] || categoryName).filter(Boolean);
};

/**
 * Получает английский ID категории по её русскому названию
 * @param categoryName - русское название категории
 * @returns английский ID категории или исходное название, если маппинг не найден
 */
export const getCategoryEnglishId = (categoryName: string): string => {
    return reverseCategoryMap[categoryName] || categoryName;
};
